// extracted by mini-css-extract-plugin
export var changeIcon = "_73-4";
export var container = "_73-0";
export var divider = "_73-7";
export var externalLinkIcon = "_73-1";
export var green = "_73-5";
export var helpCircleIcon = "_73-3";
export var iconButton = "_73-2";
export var red = "_73-6";